export enum ChargeStatus {    
    Unknown = 0,
    Accepted = 1,
    Disputed = 2
}